import { render, staticRenderFns } from "./CommonLogin.vue?vue&type=template&id=6a9bf5c6&scoped=true"
import script from "./CommonLogin.vue?vue&type=script&lang=js"
export * from "./CommonLogin.vue?vue&type=script&lang=js"
import style0 from "./CommonLogin.vue?vue&type=style&index=0&id=6a9bf5c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9bf5c6",
  null
  
)

export default component.exports